<template>
  <div class="match-data">
    <div class="match">
      <div class="match-name">
        <span>{{ match.chineseName }}</span>
      </div>
      <div class="group">组别：<span style="font-size: 13px; color: #333333; font-weight: 500">{{ match.group }}</span></div>
      <div class="data">
        <div class="data-item">
          <div class="number">{{ match.allIP }}</div>
          <div class="label">上场局数</div>
        </div>
        <div class="data-item">
          <div class="number">{{ match.allR }}</div>
          <div class="label">得分</div>
        </div>
        <div class="data-item">
          <div class="number">{{ match.allH }}</div>
          <div class="label">安打</div>
        </div>
        <div class="data-item">
          <div class="number">{{ match.allNH }}</div>
          <div class="label">非安打上垒</div>
        </div>
      </div>
    </div>
    <div class="match" v-for="(game, index) in list" :key="'match' + index">
      <div class="match-name">
        <div class="icon"></div>
        <span style="font-size: 13px; color: #333333">{{ game.homeTeamName }}({{ game.homeScore }}) - {{ game.awayTeamName }}({{ game.homeScore }})  {{ game.stageName }} 第{{ game.round }}轮</span>
      </div>
      <div class="group">开赛时间：<span style="font-size: 12px; color: #333333">{{ getFormatDate(game.beginDate) }}</span></div>
      <div class="data">
        <div class="data-item">
          <div class="number">{{ game.allIP }}</div>
          <div class="label">上场局数</div>
        </div>
        <div class="data-item">
          <div class="number">{{ game.allR }}</div>
          <div class="label">得分</div>
        </div>
        <div class="data-item">
          <div class="number">{{ game.allH }}</div>
          <div class="label">安打</div>
        </div>
        <div class="data-item">
          <div class="number">{{ game.allNH }}</div>
          <div class="label">非安打上垒</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DateUtil } from "@/utils";
import { getBMMLBMatchBaseballStatsByUser } from "@/api/match";

export default {
  data() {
    return {
      match: {},
      list: [],
      matchId: '',
      IDCardNo: ''
    }
  },
  mounted() {
    this.matchId = this.$route.params.matchId
    this.IDCardNo = this.$route.query.IDCardNo
    this.getBMMLBMatchBaseballStatsByUser()
  },
  methods: {
    getBMMLBMatchBaseballStatsByUser() {
      const params = {
        matchId: this.matchId,
        IDCardNo: this.IDCardNo
      }
      getBMMLBMatchBaseballStatsByUser(params).then(res => {
        if (res) {
          const { data } = res
          this.match = data.matchStats || {}
          this.list = data.gameStats || []
        }
      })
    },
    getFormatDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{y}-{m}-{d} {h}:{i}')
    }
  }
}
</script>

<style lang="scss" scoped>
.match-data {
  background-color: #F6F6F8;
  min-height: 100vh;
  padding: 20px 12px;
  .match {
    background-color: #ffffff;
    padding: 0 12px;
    border-radius: 8px;
    .match-name {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #333333;
      padding: 12px 0;
      border-bottom: 0.5px #EEEEEE solid;
      .icon {
        width: 2px;
        height: 12px;
        background-color: red;
        margin-right: 6px;
      }
    }
    .group {
      font-size: 12px;
      display: flex;
      align-items: center;
      color: #8C8C8C;
      padding: 8px 0 5px 0;
    }
    .data {
      display: flex;
      justify-content: space-around;
      margin-bottom: 12px;
      .data-item {
        display: flex;
        flex-flow: column;
        align-items: center;
        padding-bottom: 8px;
        width: 80px;
        .number {
          font-size: 18px;
          font-weight: 500;
          padding: 4px 0;
        }
        .label {
          font-size: 12px;
          color: #8C8C8C;
        }
      }
    }
  }
}
</style>
